import {Button, CardHeader, Checkbox, GlobalStyles, Grid, List, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";

const LIMIT_MESSAGE_PER_REQUEST = 2;
const REQUEST_INTERVAL = 5000;

const MIN_REQUEST_INTERVAL = 1000;
const MAX_REQUEST_INTERVAL = 100000;
const MIN_LIMIT_MESSAGE_PER_REQUEST = 1;
const MAX_LIMIT_MESSAGE_PER_REQUEST = 100;

export class ChatManagement extends React.Component<any, any> {
    chatContainerRef: any;
    timer: any;
    constructor(props: any) {
        super(props);

        this.state = {
            closedChannels: [],
            channels: [],
            liveChat: {
                currentChannel: "",
                channelInfos: []
            },
            squads: [],
            chosenSquad: "",
            limitMessagePerRequest: LIMIT_MESSAGE_PER_REQUEST,
            requestInterval: REQUEST_INTERVAL,
            config: {
                limitMessagePerRequest: LIMIT_MESSAGE_PER_REQUEST,
                requestInterval: REQUEST_INTERVAL,
            },
            selectingChat: false,
            selectedChats: [],
        }

        this.chatContainerRef = React.createRef();
    }

    componentDidMount() {
        this.getChatMaintenance();
    }

    componentDidUpdate() {
        const {liveChat} = this.state;
        const channelInfo = this.getChannelInfo(liveChat.currentChannel);

        if (channelInfo.shouldScrollToBottom) {
            this.scrollToBottom();
        }
    }

    componentWillUnmount(): void {
        clearInterval(this.timer);
    }

    scrollToBottom() {
        if (this.chatContainerRef.current) {
            this.chatContainerRef.current.scrollTop = this.chatContainerRef.current.scrollHeight;
        }
    }

    async getChatMaintenance() {
        const url = `${Config.getInstance.apiUrl}/api/chat/maintenance`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {headers});

        const success = response.status == 200;

        if (success) {
            const data = response.data;
            const channels = data.channels;
            const squads = data.squads;
            const {liveChat} = this.state;

            if (channels && channels.length > 0 && !liveChat.currentChannel) {
                liveChat.currentChannel = data.channels[0].value;
            }



            this.setState({
                closedChannels: data.closedChannels,
                channels: data.channels,
                liveChat,
                squads,
                chosenSquad: squads.length > 0 ? squads[0].id : "",
            });

            this.startTimer();
        } else {
            PopupMessage.error("Error Fetching Data");
        }
    }

    startTimer() {
        this.timer = setInterval(() => {
            this.getLiveChat();
        }, this.state.requestInterval);
    }

    toggleSelectChat() {
        this.setState({
            selectingChat: !this.state.selectingChat,
        });
    }

    onSelectAll() {
        const {liveChat, selectedChats} = this.state;
        const channelInfo = this.getChannelInfo(liveChat.currentChannel);
        const chats = channelInfo.chats;

        if (selectedChats.length == chats.length) {
            this.setState({
                selectedChats: [],
            });
        } else {
            this.setState({
                selectedChats: chats.map((chat: any) => chat.id),
            });
        }
    }

    async deleteSelectedChats() {
        const {selectedChats, liveChat} = this.state;

        if (confirm(`Are you sure you want to delete these ${selectedChats.length} chat(s)?`)) {
            const url = `${Config.getInstance.apiUrl}/api/chat/delete`;
            const headers = {
                Authorization: Helpers.getSessionId(),
            }
            const body = {
                ids: selectedChats,
                channel: liveChat.currentChannel,
            }
            // POST request
            const result = await axios.post(url, body, {headers});

            const success = result.status == 200;

            if (success) {
                PopupMessage.success("Delete Success");
                const channelInfo = this.getChannelInfo(liveChat.currentChannel);
                channelInfo.chats = channelInfo.chats.filter((chat: any) => !selectedChats.includes(chat.id));

                this.setState({
                    selectedChats: [],
                    liveChat,

                });
            } else {
                PopupMessage.error("Error Deleting Data");
            }
        }
    }

    async getLiveChat() {
        // If selecting chat, return
        if (this.state.selectingChat) {
            return;
        }

        const url = `${Config.getInstance.apiUrl}/api/chat/live_chat`;

        const channelInfo = this.getChannelInfo(this.state.liveChat.currentChannel);

        const channel = this.state.liveChat.currentChannel;
        // if channel === tournament, return
        if (channel == "tournament") {
            PopupMessage.error("Tournament channel is not supported");
            return;
        }

        const params = {
            channel: this.state.liveChat.currentChannel,
            offset: channelInfo.offset,
            limit: this.state.limitMessagePerRequest,
            latest: channelInfo.latest,
            chosenSquad: this.state.chosenSquad,
        }

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.get(url, {params, headers});
        const data = response.data;

        const success = data.success;
        if (success) {

            const incomingMessage = data.liveChat;
            channelInfo.chats = incomingMessage.concat(channelInfo.chats);

            // Sort by createdAt ACS
            channelInfo.chats.sort((a: any, b: any) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);

                return dateA.getTime() - dateB.getTime();
            });

            // Remove duplicate
            const uniqueIds = new Set<string>();
            channelInfo.chats = channelInfo.chats.filter((chat: any) => {
                if (!uniqueIds.has(chat.id)) {
                  uniqueIds.add(chat.id);
                  return true;
                }
                return false;
              });
            

            channelInfo.offset += incomingMessage.length;

            if (incomingMessage.length > 0) {
                channelInfo.shouldScrollToBottom = true;

                // Update latest 
                channelInfo.latest = channelInfo.chats.reduce((a: any, b: any) => {
                    return a.createdAt > b.createdAt ? a : b;
                }).createdAt;
            } else {
                channelInfo.shouldScrollToBottom = false;
            }

            this.setState({
                liveChat: this.state.liveChat
            })
        }
    }

    onSwitchChange(channel: string, checked: boolean) {
        const {closedChannels} = this.state;
        const newClosedChannels = checked ? closedChannels.concat(channel) : closedChannels.filter((c: string) => c != channel);
        this.setState({
            closedChannels: newClosedChannels,
        });
    }

    async updateChatMaintenance() {
        const url = `${Config.getInstance.apiUrl}/api/chat/maintenance`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const response = await axios.post(url, {closedChannels: this.state.closedChannels}, {headers});

        const success = response.status == 200;

        if (success) {
            PopupMessage.success("Success");
            this.getChatMaintenance();
        } else {
            PopupMessage.error("Error Updating Data");
        }
    }

    onSwitchChannel(e) {
        const {liveChat} = this.state;
        liveChat.currentChannel = e.target.value;
        this.setState({
            liveChat
        });
    }

    onChangeConfig(e, key: string) {
        const {config} = this.state;
        config[key] = e.target.value;
        this.setState({
            config
        });
    }

    getChannelInfo(channel: string) {
        const {liveChat} = this.state;
        const {channelInfos} = liveChat;

        let channelInfo = channelInfos.find((c: any) => c.channel == channel);

        if (!channelInfo) {
            // push new channel info
            channelInfo = {
                channel,
                chats: [],
                offset: 0,
                isFree: true,
                shouldScrollToBottom: true,
                latest: '',
            };

            channelInfos.push(channelInfo);
        }

        return channelInfo;
    }

    applyConfig() {
        const {config} = this.state;
        let {limitMessagePerRequest, requestInterval} = config;

        // check min max
        limitMessagePerRequest = Math.max(MIN_LIMIT_MESSAGE_PER_REQUEST, limitMessagePerRequest);
        limitMessagePerRequest = Math.min(MAX_LIMIT_MESSAGE_PER_REQUEST, limitMessagePerRequest);

        requestInterval = Math.max(MIN_REQUEST_INTERVAL, requestInterval);
        requestInterval = Math.min(MAX_REQUEST_INTERVAL, requestInterval);

        // Update config
        config.limitMessagePerRequest = limitMessagePerRequest;
        config.requestInterval = requestInterval;

        // Reset timer
        clearInterval(this.timer);
        this.startTimer();

        this.setState({
            config,
            limitMessagePerRequest,
            requestInterval,
        });
    }

    onSelectedChatChange(e: any, id: string) {
        const {selectedChats} = this.state;

        if (e.target.checked) {
            selectedChats.push(id);
        } else {
            const index = selectedChats.indexOf(id);
            if (index > -1) {
                selectedChats.splice(index, 1);
            }
        }

        this.setState({
            selectedChats,
        });
    }

    findSelectedChat = (id: string) => {
        return this.state.selectedChats.includes(id);
    }

    onSwitchSquad(e) {
        const squad = e.target.value;
        const {liveChat, chosenSquad} = this.state;

        if (chosenSquad == squad) {
            return;
        }

        // Reset offset
        const channelInfo = this.getChannelInfo(liveChat.currentChannel);
        channelInfo.offset = 0;
        channelInfo.chats = [];

        this.setState({
            chosenSquad: squad,
            liveChat,
        });
    }

    parseTime(time: string) {
        // time = 2024-01-16T12:40:06.107Z
        const date = new Date(time);

        // Format to HH:MM:SS
        const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
        const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
        const seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();

        return `${hours}:${minutes}:${seconds}`;
    }

    renderChannelMaintenance() {
        const {closedChannels, channels} = this.state;
        return <Paper className="root" elevation={0} style={{width: "100%"}}>
            <CardHeader title="Channel Maintenance" />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Channel</TableCell>
                        <TableCell>Maintenance</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        channels.map((channel: any) => {
                            return <TableRow key={channel.key}>
                                <TableCell>{channel.key}</TableCell>
                                <TableCell>
                                    <Switch
                                        checked={closedChannels.includes(channel.value)}
                                        onChange={(e: any) => this.onSwitchChange(channel.value, e.target.checked)}
                                    />
                                </TableCell>
                            </TableRow>
                        })
                    }

                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>
                            <Button
                                style={{float: "right"}} variant="contained" color="primary"
                                onClick={() => this.updateChatMaintenance()}
                            >
                                Submit
                            </Button>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    }

    renderMessageBlob(data: any, index: number) {
        const {username, message, createdAt, id, selectedChats} = data;

        const blobStyle = {
            //background: 'linear-gradient(90deg, rgba(9,4,98,1) 0%, rgba(36,62,44,1) 50%, rgba(32,145,168,1) 100%), rgb(79, 74, 163)',
            width: '100%',
            minWidth: '100px',
            // maxHeight: '100px',
            minHeight: '80px',
            borderRadius: '20px',
            padding: '10px',
            position: 'relative',
            wordWrap: 'break-word', // Allow words to break and wrap to the next line
            overflowWrap: 'break-word', // Handle overflow at word boundaries
            whiteSpace: 'pre-wrap'
        } as React.CSSProperties;

        const usernameStyle = {
            fontSize: '20px',
            fontWeight: 'bold',
            marginBottom: '5px',
        } as React.CSSProperties;

        const timeStyle = {
            fontSize: '14px',
        } as React.CSSProperties;

        const containerStyle = {
            marginBottom: '2%',
        } as React.CSSProperties;

        return (
            <Grid container style={containerStyle} key={index}>
                {this.state.selectingChat && (
                    <Grid item>
                        <Checkbox
                            checked={this.findSelectedChat(id)}
                            style={{marginRight: '10px'}}
                            onClick={(e) => this.onSelectedChatChange(e, id)}
                        />
                    </Grid>
                )}
                <Grid item xs={this.state.selectingChat ? 9 : 12}>
                    <Typography variant="subtitle1" style={usernameStyle}>
                        {`-${username || "noname"}`}
                        <span style={timeStyle}> ({this.parseTime(createdAt)}):</span>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <div style={blobStyle}>
                        {message}
                    </div>
                </Grid>
            </Grid>
        );
    }

    renderLiveChat() {
        if (!this.state.liveChat.currentChannel) {
            return null
        }
        const style = {
            chatContainer: {
                maxHeight: '400px', // Set your desired max height here
                padding: '10px',
                width: '100%',
                backgroundColor: "black",
            } as React.CSSProperties,
            messageList: {
                maxHeight: 400,
                marginBottom: 2,
                overflow: 'auto',
            } as React.CSSProperties,
        }

        const channelInfo = this.getChannelInfo(this.state.liveChat.currentChannel);
        const {chats} = channelInfo;

        return <Paper style={style.chatContainer}>
            <GlobalStyles
                styles={{
                    '*::-webkit-scrollbar': {
                        width: '0.4em',
                    },
                    '*::-webkit-scrollbar-track': {
                        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
                    },
                    '*::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,.1)',
                        outline: '1px solid slategrey',
                    },
                }}
            />
            <List style={style.messageList}
                ref={this.chatContainerRef}
            >
                {
                    chats.map((chat: any, index: number) => {
                        return this.renderMessageBlob(chat, index);
                    })
                }
            </List>
        </Paper>
    }

    renderLiveChatTable() {
        const {liveChat, channels, chosenSquad, config} = this.state;
        const {limitMessagePerRequest, requestInterval} = config;
        const channelInfo = this.getChannelInfo(liveChat.currentChannel);

        const bottomLineStyle = {
            borderBottom: "1px solid #e0e0e0"
        }

        const blockScrollStyle = {
            overflow: "hidden",
            height: "400px",
        }

        const buttonContainerStyle = {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            alignItems: "flex-end",
        }

        const buttonStyle = {
            width: "80%",
            maxWidth: "150px",
            height: "70%",
        }

        return <Paper className="root" elevation={0} style={{width: "100%"}}>
            <CardHeader title="Live Chat" />
            <Grid container>
                <Grid container spacing={2}>
                    <Grid item sm={4}>
                        <Typography variant="h6">Interval (ms):</Typography>
                        <TextField
                            size="small"
                            variant="outlined"
                            value={requestInterval}
                            onChange={(e: any) => this.onChangeConfig(e, "requestInterval")}
                        />
                    </Grid>

                    <Grid item sm={4}>
                        <Typography variant="h6">Request amount:</Typography>
                        <TextField
                            size="small"
                            variant="outlined"
                            value={limitMessagePerRequest}
                            onChange={(e: any) => this.onChangeConfig(e, "limitMessagePerRequest")}
                        />
                    </Grid>

                    <Grid item sm={4} style={buttonContainerStyle}>
                        <Button
                            style={buttonStyle}
                            variant="contained" color="primary"
                            onClick={() => this.applyConfig()}
                        >
                            Update Config
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={1} style={bottomLineStyle}>
                    <Grid item sm={4}>
                        <Typography variant="h6">Channel:</Typography>
                        <Select
                            value={liveChat.currentChannel}
                            size="small"
                            variant="outlined"
                            style={{width: "100%"}}
                            onChange={(e: any) => this.onSwitchChannel(e)}
                        >
                            {
                                channels.map((channel: any) => {
                                    return <MenuItem key={channel.key} value={channel.value}>{channel.key}</MenuItem>
                                })
                            }
                        </Select>
                    </Grid>
                    {
                        liveChat.currentChannel == "alliance" ? <Grid item sm={4}>
                            <Typography variant="h6">Alliance:</Typography>
                            <Select
                                value={chosenSquad}
                                size="small"
                                variant="outlined"
                                style={{width: "100%"}}
                                onChange={(e: any) => this.onSwitchSquad(e)}
                            >
                                {
                                    this.state.squads.map((squad: any) => {
                                        return <MenuItem key={squad.id} value={squad.id}>{squad.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </Grid>
                            : <Grid item sm={4}></Grid>
                    }
                </Grid>

                <Grid container spacing={1}>
                    <Grid item sm={3} style={buttonContainerStyle}>
                        <Button
                            variant="contained"
                            color={this.state.selectingChat ? "warning" : "primary"}
                            onClick={() => this.toggleSelectChat()}>
                            {this.state.selectingChat ? "Stop Selecting" : "Select Chat"}
                        </Button>
                    </Grid>

                    <Grid item sm={3} style={buttonContainerStyle}>
                        {
                            this.state.selectingChat && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.onSelectAll()}>
                                    {this.state.selectedChats.length == channelInfo.chats.length && channelInfo.chats.length > 0 ? "Unselect All" : "Select All"}
                                </Button>
                            )
                        }
                    </Grid>

                    <Grid item sm={3} style={buttonContainerStyle}>
                        {
                            this.state.selectingChat && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => this.deleteSelectedChats()}>
                                    Delete
                                </Button>
                            )
                        }
                    </Grid>
                </Grid>

                <Grid container style={blockScrollStyle}>
                    {this.renderLiveChat()}
                </Grid>
            </Grid>
        </Paper>
    }

    render() {
        return <div className="contentPadding" style={{width: "100%"}}>
            <Grid container spacing={2}>
                <Grid item sm={4}>
                    {this.renderChannelMaintenance()}

                </Grid>
                <Grid item sm={8}>
                    {this.renderLiveChatTable()}
                </Grid>
            </Grid>
        </div>
    }
}